import React from 'react';
import PropTypes from 'prop-types';
const has = require('lodash/has');
import { Form } from 'react-bootstrap';

const GlobalUserActions = require('../../actions/GlobalUserActions');
const GlobalUserStore = require('../../stores/GlobalUserStore');
import AccessibleIcon from './AccessibleIcon';

const propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    className: PropTypes.string,
    onValidated: PropTypes.func
};

const defaultProps = {
    value: '',
    label: 'email address',
    className: '',
    onValidated: null
};

class EmailAvailabilityChecker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            valid: false,
            showValidity: false,
            validityMessage: null,
            globalUserStoreState: GlobalUserStore.getState()
        };

        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.checkAvailability = this.checkAvailability.bind(this);
        this.unsubscribes = [ GlobalUserStore.listen(this.onGlobalUserStoreStateChange.bind(this)) ]
    }

    componentDidUpdate(prevProps) {
        if (!this.state.showValidity) return;

        if (prevProps.value !== this.props.value) {
            this.setState({ showValidity: false });
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onGlobalUserStoreStateChange(newState) {
        let updatedState = {};

        if (has(newState.emailAvailability), this.props.value) {
            const valid = newState.emailAvailability[this.props.value].available;
            updatedState = {
                ...updatedState,
                showValidity: true,
                valid: valid,
                validityMessage : newState.emailAvailability[this.props.value].message
            };

            if (valid && !!this.props.onValidated) {
                this.props.onValidated();
            }
        }

        this.setState(updatedState);
    }

    checkAvailability() {
        return GlobalUserActions.getAvailable('emailAvail', { email: this.props.value }); // emailAvail actionId is an unused placeholder
    }

    onChange(e) {
        if (!this.props.onChange) {
            return;
        }

        this.props.onChange(e.target.value);
    }

    onBlur(e) {
        if (!this.props.value) {
            return;
        }

        this.checkAvailability();
    }

    render() {
        return (
            <div className={`inputRowFlex ${this.props.className}`}>
                <div className="inputRowFlex__input">
                    <Form.Group controlId={this.props.id}>
                        <Form.Label>{this.props.label}</Form.Label>
                        <Form.Control
                            type="text"
                            aria-label="email address"
                            value={this.props.value}
                            onChange={this.onChange}
                            onBlur={this.onBlur}
                            isInvalid={(this.state.showValidity && !this.state.valid)}
                        />
                    </Form.Group>
                </div>
                {(this.state.showValidity) &&
                    <div className="inputRowFlex__feedback">
                        { this.state.valid ?
                            <AccessibleIcon
                                className="color-valid"
                                label="Available"
                            >
                                <span className="fa fa-check fa-lg" aria-hidden={true}/>
                            </AccessibleIcon>
                            :
                            <AccessibleIcon
                                className="color-invalid"
                                label="Unavailable"
                            >
                                <span className="fa fa-remove fa-lg" aria-hidden={true}/>
                            </AccessibleIcon>
                        }
                    </div>
                }
                {(this.state.showValidity) &&
                    <div className="inputRowFlex__feedback">
                        { this.state.validityMessage }
                    </div>
                }
            </div>
        );
    }
}

EmailAvailabilityChecker.propTypes = propTypes;
EmailAvailabilityChecker.defaultProps = defaultProps;

export default EmailAvailabilityChecker;